export default {
      id: "guide-icon-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#guide-icon-usage",
      toString: function () {
        return this.url;
      }
    }